import { render, staticRenderFns } from "./Inscriptions.vue?vue&type=template&id=55c1e9da&"
import script from "./Inscriptions.vue?vue&type=script&lang=js&"
export * from "./Inscriptions.vue?vue&type=script&lang=js&"
import style0 from "./Inscriptions.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports